// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__T3JaN","label":"Category_label__anLce","content":"Category_content__1bMbX","header":"Category_header__M3HGG","location":"Category_location__1M2qO"};